import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AuthInput } from "../../../components/AuthInput/input";
import { YellowButton } from "../../../components/UI/Button/button";
import classes from "../index.module.css";
import { checkMail } from "../../../utils/functions";
import { postSupportComplaint as postTalentSupportComplaint } from "../../../services/talentCalls";
import { postSupportComplaint as postClientSupportComplaint } from "../../../services/clientCalls";
import PhoneNumberInput from "../../../components/UI/PhoneNumber/phonenumber";
import confusedStan from "../../../assets/illustrations/approving-stan-blue.png";
import ErrorModal from "../../../layout/ErrorModal/ErrorModal";
import FullScreenLoader from "../../../components/Loaders/FullScreen/loader";

const ContactUs = () => {
  const location = useLocation();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [data, setData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const getUserType = () => {
    const pathname = location.pathname;
    if (pathname.includes("/talent")) return "talent";
    if (pathname.includes("/client")) return "client";
    return "unknown";
  };

  const getSupportType = () => "Contact";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const payload = {
        supportType: getSupportType(),
        fullName: data.name,
        email: data.email,
        phoneNumber: data.phone,
        message: data.message
      };

      const userType = getUserType();

      if (userType === "talent") {
        await postTalentSupportComplaint(payload);
      } else if (userType === "client") {
        await postClientSupportComplaint(payload);
      } else {
        throw new Error("Unknown user type in pathname");
      }

      setShowSuccessModal(true);
      setData({ name: "", email: "", phone: "", message: "" });
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const props1 = {
    type: "text",
    label: "Full Name*",
    placeholder: "Jane Doe",
    value: data.name,
    onChange: (e) =>
      setData((prevState) => ({ ...prevState, name: e.target.value })),
    isValid: data.name?.length > 3,
    text: "Invalid Full Name",
    name: "Full Name",
    id: "name",
  };

  const props2 = {
    type: "text",
    label: "Email Address*",
    placeholder: "Janedoe@awasource.com",
    value: data.email,
    onChange: (e) =>
      setData((prevState) => ({ ...prevState, email: e.target.value })),
    isValid: checkMail(data.email),
    text: "Invalid Email Address",
    name: "Email Address",
    id: "email",
  };

  return (
    <div className={classes.main}>
      {isSubmitting && <FullScreenLoader />}
      <h3 className="t-24 mb-md">Contact Us</h3>
      <div>
        <form onSubmit={handleSubmit}>
          <p className="mb-md t-md">
            Contact us directly, and we will get back to you as soon as possible
          </p>
          <AuthInput {...props1} />
          <AuthInput {...props2} />
          <PhoneNumberInput
            value={data.phone}
            label="Phone Number*"
            onChange={(e) =>
              setData((prevState) => ({ ...prevState, phone: e }))
            }
          />
          <label>How can we help you?*</label>
          <textarea
            style={{ resize: "none" }}
            value={data.message}
            onChange={(e) =>
              setData((prevState) => ({ ...prevState, message: e.target.value }))
            }
          ></textarea>
          <span className={classes.info}>
            Any information you provide is in accordance with our{" "}
            <Link to="/privacy-policy">Privacy Policy</Link> &
            <Link to="/terms-of-service"> Terms of Use</Link>
          </span>
          <YellowButton
            disabled={
              !data.name ||
              !checkMail(data.email) ||
              !data.message ||
              !data.phone ||
              isSubmitting
            }
            type="submit"
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </YellowButton>
        </form>
      </div>

      {showSuccessModal && (
        <ErrorModal
          isModalOpen={showSuccessModal}
          setModalOpen={setShowSuccessModal}
        >
          <div style={{
            backgroundColor: '#0A0F8F',
            padding: '50px 110px',
            borderRadius: '8px',
            textAlign: 'center',
            color: 'white',
            width: '100%',
            boxSizing: 'border-box'
          }}>
            <img
              src={confusedStan}
              alt="Success confirmation"
              style={{ width: '150px', marginBottom: '20px' }}
            />
            <p style={{ fontSize: '18px', marginBottom: '10px' }}>
              Thanks for your feedback
            </p>
            <p style={{ fontSize: '14px', lineHeight: '1.5' }}>
              We will get back to you soon.
            </p>
          </div>
        </ErrorModal>
      )}
    </div>
  );
};

export default ContactUs;
